<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AobSP9/tc-custom/9781488057038.jpg?1707880335402" alt="This image is the cover for the book Hard Ride, The Clean Slate Ranch Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard Ride, The Clean Slate Ranch Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A fake relationship with a rugged cowboy leads to casual fun and very real feelings in this contemporary gay romance.</b><br/><br/>City slicker Derrick Massey has always had a thing for cowboys. So a roll in the hay with Kendall “Slater” Stamos during a rustic weekend wedding is more than A-OK. But when Slater’s forced to hang up his saddle for the season, Derrick surprises even himself with his proposition: <i>be my fake boyfriend and get my family off my back about finding a permanent partner.</i><br/><br/>Though unexpected, the arrangement is a win-win. Derrick gets a plus-one for a slew of summer weddings and Slater gets a place to stay while he recuperates . . . with lots of casual fun in between. Which is just how the sexy cowboy likes it: casual. Yet it’s obvious the chemistry between them is anything but.<br/><br/>With the countdown to their “breakup” on, the more time the two men spend together. And the more it becomes clear that what they have could be real, if only they let it be.<br/><br/><b>Praise for <i>Hard Ride</i></b><br/><br/>“A.M. Arthur’s <i>Hard Ride </i>is an unputdownable, super sexy read with lots of personality and a ton of heart. I enthusiastically recommend it to all readers.” —<i>All About Romance</i><br/><br/>“Scintillating romantic tension and steamy sex scenes. . . . Passionate . . . entertaining.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.M. Arthur
      </h2>
      
      <p class="authorDescription body article">A.M. Arthur was born and raised in the same kind of small town she likes to write about, a stone's throw from both the ocean and generational farmland. She's been writing stories in her head since she was a child and scribbling them down nearly as long. When not exorcising the voices in her head, A.M. can be found in the kitchen experimenting with food and trying not to poison herself or others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?087c957f